var map = {
	"./Group 1673.png": "146e",
	"./aa.jpg": "bea1",
	"./about1.png": "4f9f",
	"./about2.png": "a446",
	"./about22.png": "a664",
	"./about3.png": "6b0d",
	"./about4.png": "ad7e",
	"./about5.png": "5d8a",
	"./about6.png": "6a44",
	"./aboutUs/about1.jpg": "87bf",
	"./aboutUs/about3.jpg": "1c10",
	"./aboutUs/about4.jpg": "c0e5",
	"./aboutUs/about5.jpg": "8c68",
	"./aboutUs/about6.jpg": "88e2",
	"./aboutUs/about8.jpg": "5bf8",
	"./aboutUs/showregis1.png": "4b43",
	"./bed.png": "5dfe",
	"./bg-home.png": "d6f1",
	"./bg-home1.png": "bb12",
	"./bg-home2.png": "468d",
	"./bg-modal.png": "88b3",
	"./blog1.png": "baad",
	"./blog2.png": "8dfc",
	"./blog3.png": "d63a",
	"./blog4.png": "2fe9",
	"./blog5.png": "99ac",
	"./blog6.png": "248d",
	"./blog7.png": "322d",
	"./circle.png": "69d9",
	"./close.png": "0c23",
	"./cmex.png": "1a32",
	"./computer.png": "03be",
	"./doctor.png": "eff1",
	"./group-logo.png": "0e30",
	"./head-home.png": "9f44",
	"./home-smid.png": "2276",
	"./home-smid1.png": "9886",
	"./icon/clock.svg": "e10c",
	"./icon/data.svg": "95e5",
	"./icon/doctor.svg": "caa9",
	"./icon/facebook.svg": "e228",
	"./icon/handshake-white.svg": "6b87",
	"./icon/handshake.svg": "908d",
	"./icon/hospital.svg": "6a50",
	"./icon/hospital1.svg": "4b89",
	"./icon/idea.svg": "bff1",
	"./icon/info.svg": "30b1",
	"./icon/innovation.svg": "7be3",
	"./icon/layers.svg": "5c3e",
	"./icon/line.svg": "914f",
	"./icon/map.svg": "c925",
	"./icon/messenge.svg": "19d1",
	"./icon/messengeCard.svg": "c8ed",
	"./icon/microscop-white.svg": "7372",
	"./icon/microscop.svg": "e117",
	"./icon/network.svg": "6065",
	"./icon/phone.svg": "db97",
	"./icon/physics.svg": "0bae",
	"./icon/profit.svg": "8719",
	"./icon/quality.svg": "97e1",
	"./icon/regis_news.svg": "4259",
	"./icon/regis_schedule.svg": "cfeb",
	"./icon/regis_search.svg": "729b",
	"./icon/right_arrow.svg": "7c88",
	"./icon/search.svg": "a32f",
	"./icon/seemap.svg": "f95b",
	"./icon/user-gray.svg": "d3b2",
	"./icon/user-white.svg": "b18a",
	"./icon/user.svg": "4c86",
	"./icon/website.svg": "204d",
	"./icon/welfare.svg": "9b21",
	"./icon/youtube.svg": "a1db",
	"./innovationall/innovation1.svg": "64d6",
	"./innovationall/innovation2.svg": "84d8",
	"./innovationall/innovation3.svg": "5220",
	"./innovationall/innovation4.svg": "7fb5",
	"./innovationall/innovation5.svg": "f6e2",
	"./innovationall/innovation6.svg": "d84b",
	"./invester1.png": "64de",
	"./invester11.png": "e43a",
	"./invester2.png": "9fef",
	"./invester3.png": "76c3",
	"./location.png": "24a7",
	"./location1.png": "d257",
	"./location222.png": "ee7b",
	"./logo_footer.png": "9aee",
	"./logo_header.png": "42c8",
	"./logo_header1.png": "9f35",
	"./logo_main.png": "c1cb",
	"./nurse.png": "fc4e",
	"./partner.png": "8694",
	"./partners/logo-med2.png": "8d8c",
	"./partners/logo_arch.png": "4373",
	"./partners/logo_boi.png": "286a",
	"./partners/logo_chiangmairam.png": "a991",
	"./partners/logo_chivacare.png": "6c2d",
	"./partners/logo_cm.png": "12e7",
	"./partners/logo_cm_co.png": "163c",
	"./partners/logo_cmex.png": "9dfc",
	"./partners/logo_cmneuro.png": "c7f8",
	"./partners/logo_dent.png": "6999",
	"./partners/logo_entaneer.png": "b855",
	"./partners/logo_hokankr.png": "e61c",
	"./partners/logo_med.png": "6326",
	"./partners/logo_med2.png": "340d",
	"./partners/logo_medtech.png": "dda1",
	"./partners/logo_nakorncm.png": "78f1",
	"./partners/logo_nia.png": "4f81",
	"./partners/logo_nst.png": "5e63",
	"./partners/logo_nstda.png": "49c1",
	"./partners/logo_nursing.png": "4986",
	"./partners/logo_pharmacy.png": "26bb",
	"./partners/logo_publichealth.png": "2298",
	"./partners/logo_punspace.png": "d6a9",
	"./partners/logo_sapar.png": "74f8",
	"./partners/logo_step.png": "565d",
	"./partners/logo_tcels.png": "5d16",
	"./partners/mhesi.png": "41a6",
	"./partners/nia12.png": "0d66",
	"./regis-now.png": "94ec",
	"./service.png": "c422",
	"./service1.png": "c1c7",
	"./service2.png": "9436",
	"./service3.png": "a49e",
	"./serviceall/service1.svg": "f0c3",
	"./serviceall/service10.svg": "c1b7",
	"./serviceall/service11.svg": "aa0c",
	"./serviceall/service12.svg": "0fb3",
	"./serviceall/service13.svg": "b91b",
	"./serviceall/service14.svg": "8d15",
	"./serviceall/service15.svg": "2d53",
	"./serviceall/service16.svg": "c0a7",
	"./serviceall/service17.svg": "01d2",
	"./serviceall/service18.svg": "e475",
	"./serviceall/service19.svg": "4764a",
	"./serviceall/service2.svg": "ec87",
	"./serviceall/service20.svg": "d02b",
	"./serviceall/service21.svg": "16e1",
	"./serviceall/service22.svg": "cd92",
	"./serviceall/service23.svg": "b3c8",
	"./serviceall/service24.svg": "8217",
	"./serviceall/service25.svg": "a9b3",
	"./serviceall/service26.svg": "9a79",
	"./serviceall/service27.svg": "97d9",
	"./serviceall/service3.svg": "55c0",
	"./serviceall/service4.svg": "884c",
	"./serviceall/service5.svg": "64385",
	"./serviceall/service6.svg": "2589",
	"./serviceall/service7.svg": "7383",
	"./serviceall/service8.svg": "eaaf",
	"./serviceall/service9.svg": "c00d",
	"./showregis1.png": "25b0",
	"./showregis11.png": "36e0",
	"./showregis2.png": "b5e0",
	"./showregis22.png": "befa",
	"./showregis3.png": "0f2e",
	"./showregis33.png": "d033",
	"./sleepcenter.png": "995a",
	"./slide1.png": "ca3b",
	"./slide2.png": "8def",
	"./slide3.png": "5c0e",
	"./slide33.png": "cb72",
	"./slide4.png": "af22",
	"./special-banner.png": "d068",
	"./student.png": "d578",
	"./ttcm.png": "c4aa",
	"./user.jpg": "b7b3",
	"./user.png": "6e6d",
	"./video/SMID-intro1.mp4": "ca26",
	"./video/SMID-intro2.mp4": "e433",
	"./video/SMID-intro3.mp4": "9c35",
	"./video/SMID-intro4.mp4": "1082",
	"./women.png": "b759"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e107";